import { useEffect } from "react";

// Reload the page once a day at 4 AM to prevent memory leaks in long-running kiosk mode
export function useAutoReload() {
  useEffect(() => {
    const id = setInterval(() => {
      const now = new Date();
      if (now.getHours() === 4 && now.getMinutes() === 0) {
        window.location.reload();
      }
    }, 60_000); // check every minute
    return () => clearInterval(id);
  }, []);
}
